"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skip = void 0;
var safe_slice_1 = require("./safe-slice");
/** @internal */
var skip = function (array, num) {
    return (0, safe_slice_1.safeSlice)(array, num, array.length);
};
exports.skip = skip;
